/*
 * The two statuses the advisory API recognises. There is no `published` and no delete: an advisory
 * is retired by patching it to `revoked`, which keeps it readable in the catalog.
 */
export const ADVISORY_STATUS = {
	ACTIVE: 'active',
	REVOKED: 'revoked'
};

/*
 * `ALL` is the empty string rather than a sentinel word because `stripBlankParams` drops blank
 * values before the query string is built, and omitting `status` is exactly how the API says
 * "every status".
 */
export const ADVISORY_STATUS_FILTERS = [
	{ value: ADVISORY_STATUS.ACTIVE, label: 'Active' },
	{ value: ADVISORY_STATUS.REVOKED, label: 'Revoked' },
	{ value: '', label: 'All' }
];

export const MATCH_OPS = ['equals', 'contains', 'starts_with'];

export const MATCH_OP_LABELS = {
	'equals': 'equals',
	'contains': 'contains',
	'starts_with': 'starts with'
};

export const ADVISORY_SEVERITIES = ['low', 'medium', 'high', 'critical'];

/*
 * compass-react `Badge` takes `appearance`, not `role` - a Badge given `role` renders unstyled.
 */
export const ADVISORY_SEVERITY_APPEARANCE = {
	critical: 'danger',
	high: 'warning',
	medium: 'info',
	low: 'secondary'
};

export const ADVISORY_STATUS_APPEARANCE = {
	active: 'success',
	revoked: 'secondary'
};

export const DEFAULT_APPEARANCE = 'secondary';

export const GET_FIRMWARE_ADVISORIES_DEFAULT_QUERY_PARAMS = {
	start: 0,
	limit: 15,
	status: ADVISORY_STATUS.ACTIVE
};

/*
 * The advisory list endpoint caps `limit` at 200 like the rest of the hardware API, so the page
 * size list must not offer more.
 */
export const FIRMWARE_ADVISORIES_SIZE_PER_PAGE_LIST = [15, 30, 60, 100, 200];

export const ADVISORY_FORM_NAME = 'firmwareAdvisory';

/*
 * Create and update both return a job id rather than the advisory, so every write is followed by a
 * poll. Sixty seconds is the same budget `pollJobUntilTerminal` defaults to; it is named here so
 * the form and the revoke dialog cannot drift apart.
 */
export const ADVISORY_JOB_POLL = {
	intervalMs: 1000,
	maxAttempts: 60
};

export const EMPTY_ADVISORY_FORM_VALUES = {
	componentTypeId: '',
	manufacturerMatchOp: 'equals',
	manufacturerMatchValue: '',
	modelMatchOp: 'equals',
	modelMatchValue: '',
	affectedVersions: [],
	targetVersion: '',
	severity: '',
	kbUrl: '',
	vendorUrl: ''
};
